import { useQuery } from '@tanstack/react-query'

import { getAssignableAssigneesForDataAccessRequest } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { GetAssignableAssigneesForDataAccessRequestResponse } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetAssignableAssigneesForDataAccessRequest = (
  requestId: string,
  options?: DataAccessRequestQueryOptions<GetAssignableAssigneesForDataAccessRequestResponse, ApiErrorResponse>
) => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetAssignableAssigneesForDataAccessRequestResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.AssignableAssignees(requestId),
    queryFn: ({ signal }) => getAssignableAssigneesForDataAccessRequest(requestId, { signal }),
    enabled: withDataAccessRequestsEnabled(!!requestId && (enabledOption ?? true)),
    ...restOptions
  })
}
